import _defineProperty from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import React, { useContext, useMemo } from 'react';
import cx from 'classnames';
import { Transition, TransitionGroup } from 'react-transition-group';
import { InputField, IconButton, ModalNextProvider } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { useTableContext } from './TableContext';
import { ColumnsConfigModal } from './columnsConfig/ColumnsConfigModal';
import { messages } from './DataTable.messages';
export var TableBar = function TableBar(_ref) {
  var filterValue = _ref.filterValue,
      onFilterChange = _ref.onFilterChange,
      filterPlaceholder = _ref.filterPlaceholder,
      _ref$selectionActions = _ref.selectionActions,
      selectionActions = _ref$selectionActions === void 0 ? [] : _ref$selectionActions,
      showSelectionActions = _ref.showSelectionActions,
      disabled = _ref.disabled;
  var translator = useContext(TranslatorContext);

  var _useTableContext = useTableContext(),
      styles = _useTableContext.styles,
      columns = _useTableContext.columns;

  var columnsConfigurable = columns.configurable,
      columnsConfig = columns.config,
      setColumnsConfig = columns.setConfig;
  var columnsConfigAction = useMemo(function () {
    if (!columnsConfigurable) {
      return null;
    }

    var triggerColumnsConfigModal = function triggerColumnsConfigModal() {
      var updatedConfig;
      return _regeneratorRuntime.async(function triggerColumnsConfigModal$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _regeneratorRuntime.awrap(ModalNextProvider.showModal(React.createElement(ColumnsConfigModal, {
                initialColumns: columnsConfig
              })));

            case 3:
              updatedConfig = _context.sent;
              setColumnsConfig(updatedConfig);
              _context.next = 9;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, null, null, [[0, 7]], Promise);
    };

    return React.createElement("div", {
      className: styles.columnsConfigAction
    }, React.createElement(IconButton, {
      icon: "mi-view-column",
      label: translator(messages.columnsConfig),
      onClick: triggerColumnsConfigModal
    }));
  }, [columnsConfigurable, styles.columnsConfigAction, translator, columnsConfig, setColumnsConfig]);
  var searchWrapperClassName = cx(styles.searchWrapper, _defineProperty({}, styles.searchWrapperDisabled, disabled));
  return React.createElement("div", {
    className: styles.tableBar
  }, React.createElement(InputField, {
    id: "search",
    icon: "mi-search",
    iconPosition: "right",
    placeholder: filterPlaceholder,
    className: searchWrapperClassName,
    controlClassName: styles.search,
    onValueChange: onFilterChange,
    value: filterValue,
    editable: !disabled
  }), React.createElement("div", {
    className: styles.actionPanel
  }, showSelectionActions && React.createElement(TransitionGroup, {
    component: null
  }, React.createElement(Transition, {
    timeout: 400
  }, function (state) {
    var _cx2;

    var actionBarStyles = cx(styles.selectionActions, (_cx2 = {}, _defineProperty(_cx2, styles.withBorder, columnsConfigAction), _defineProperty(_cx2, styles.transition, state !== 'entered'), _cx2));
    var buttonsStyles = cx(styles.buttons, _defineProperty({}, styles.enter, _startsWithInstanceProperty(state).call(state, 'enter')));
    return React.createElement("div", {
      className: actionBarStyles
    }, React.createElement("div", {
      className: buttonsStyles
    }, _mapInstanceProperty(selectionActions).call(selectionActions, function (_ref2) {
      var icon = _ref2.icon,
          label = _ref2.label,
          callback = _ref2.callback;
      return React.createElement(IconButton, {
        key: label,
        icon: icon,
        label: label,
        onClick: callback
      });
    })));
  })), columnsConfigAction));
};
TableBar.__docgenInfo = {
  componentName: "TableBar",
  packageName: "@jutro/datatable",
  description: "",
  displayName: "TableBar",
  methods: [],
  actualName: "TableBar",
  props: {
    selectionActions: {
      defaultValue: {
        value: "[]",
        computed: false
      },
      required: false
    }
  }
};